import React from 'react';
import LegalDocument from '../Common/LegalDocument';
import { useLocale } from '../../localization/LocaleContext';
import { getCookiePolicyPageContent } from '../../localization/legalPageContent';

export default function CookiePolicy(){
    const { locale, toLocalizedPath } = useLocale();
    const content = getCookiePolicyPageContent(locale, {
        homePath: toLocalizedPath('home')
    });

    return <LegalDocument {...content} />;
}